import XEUtils from 'xe-utils';
import MERCHANTAPI from '@/api/property/merchantCenter';
import CONTRACTAPI from '@/api/property/leaseContract';
import { auditStatusList, contractStatusList } from '../../../leaseContract/data';
import BASE_API from '@/api/dataBase.js';

export default {
  data() {
    return {
      queryData: {
        nicheCompanyNo: null,
        nicheDepartmentCode: null,
      },
      tableData: [], // 表格数据
      selectedItems: [],
      departList: [],
      auditStatusList,
      contractStatusList,
    };
  },
  methods: {
    valueChangeHandler(type, { val }) {
      console.log('valueChanged', type, val);
    },
    getStatusName(type, status) {
      if (type == 'contract') {
        switch (status) {
          case '01':
            return '待生效';
          case '02':
            return '生效中';
          case '03':
            return '已到期';
          case '04':
            return '已关闭';
          default:
            return status;
        }
      } else if (type == 'niche') {
        switch (status) {
          case '01':
            return '待签约';
          case '02':
            return '已签约';
          case '03':
            return '已关闭';
          default:
            return status;
        }
      } else if (type == 'entry') {
        if (status == '01') {
          return '待入驻';
        } else if (status == '02') {
          return '已入驻';
        }
      }
      return status;
    },
    formatDateCustom(date, needHMS = true) {
      if (!date) {
        return null;
      }
      if (!needHMS) {
        return XEUtils.toDateString(date, 'yyyy-MM-dd');
      }
      return XEUtils.toDateString(date, 'yyyy-MM-dd HH:mm:ss');
    },
    toSignContract(item) {
      console.log('signContract', item);
      const { nicheNo, id, customerName, customerCode } = item;

      let params = { nicheNo, nicheId: id, customerName, customerCode, type: 'add' };
      const path = {
        path: 'propert/addLeaseContract',
        name: 'addLeaseContract',
        meta: {
          keepAlive: true,
          title: '新建租赁合同',
        },
        query: params,
      };
      this.$router.push(path);
    },
    toLeaseContractDetail(contractId) {
      const path = {
        path: 'propert/detailLeaseContract',
        name: 'detailLeaseContract',
        meta: {
          keepAlive: true,
          title: '租赁合同详情',
        },
        query: {
          type: 'detail',
          contractId: contractId,
        },
      };
      this.$router.push(path);
    },
    async submitRelateContract(params) {
      this.loading = true;
      const { data } = await this.$axios.post(MERCHANTAPI.RELATE_CONTRACT, params);
      this.loading = false;
      if (data && data.code == 0) {
        this.$message({
          type: 'info',
          message: '关联成功',
        });
        return 'success';
      } else {
        this.$message.error(data?.msg);
      }
      return 'error';
    },
    async getContractList(query) {
      query.contractCompanyNo = this.userInfo.companyCode;
      var res = await this.$axios.post(CONTRACTAPI.LEASE_CONTRACT_LIST_PAGE, query);
      if (res.data.code === 0) {
        this.tableData = res.data.data.records || [];
        this.tableData.forEach((item) => {
          item.auditStatusName = this.transferSelect(item.auditStatus, this.auditStatusList);
          item.contractStatusName = this.transferSelect(
            item.contractStatus,
            this.contractStatusList
          );
        });
        this.$refs.siruiTable.setPageTotal(res.data.data.total);
      } else {
        this.$message.error(res.data.msg);
      }
      return [];
    },
    transferSelect(value, list, valueProp = 'value', labelField = 'label') {
      let item = XEUtils.find(list, (item) => item[valueProp] === value);
      return item ? item[labelField] : null;
    },
    async closeNiche(id) {
      this.loading = true;
      const { data } = await this.$axios.post(MERCHANTAPI.CLOSE_MERCHANT, [id]);
      this.loading = false;
      if (data && data.code == 0) {
        this.$message({
          type: 'info',
          message: '关闭成功',
        });
        this.getTableData();
      } else {
        this.$message.error(data.msg);
      }
    },

    async handleExport(items) {
      console.log('export', items);
      const { pageNum, pageSize } = this.$refs.siruiTable.page;
      const params = { ...this.queryData, pageNum, pageSize };
      const ids = [];
      items.forEach((item) => {
        ids.push(item.id);
      });
      params.ids = ids;
      this.$axios.post(MERCHANTAPI.EXPORT, params).then((res) => {
        console.log(res, 'export res');
        if (res.data.code === 0) {
          window.location.href = res.data.data;
        } else {
          this.$alert(res.data.msg);
        }
      });
    },
    toDetailPage(pageMode = 0, id) {
      let name = '';
      let subPath = '';
      let params = {};

      if (pageMode == 0) {
        subPath = 'create';
        name = 'merchantCreate';
      } else if (pageMode == 1) {
        subPath = 'detail';
        name = 'merchantDetail';
        params.id = id;
      } else if (pageMode == 2) {
        subPath = 'edit';
        name = 'merchantEdit';
        params.id = id;
      }
      params.pageMode = pageMode;

      let path = {
        path: '/property/merchant/center/' + subPath,
        name: name,
        meta: {
          keepAlive: true,
          title: name,
        },
        query: params,
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    //查询商户入驻弹窗的数据
    async getEntryDetail(id) {
      const { data } = await this.$axios.get(MERCHANTAPI.NICHE_ENTRY_DETAIL + id);
      if (data && data.data && data.code == 0) {
        return data.data;
      } else {
        this.$message.error(data.msg);
      }
      return {};
    },
    //商户入驻提交
    async submitEntry(entry) {
      const { data } = await this.$axios.post(MERCHANTAPI.NICHE_ENTRY, entry);
      if (data && data.code == 0) {
        return 'success';
      } else {
        this.$message.error(data.msg);
      }
      return 'error';
    },
    // 获取表格数据
    async getTableData() {
      let params = {};
      params = { ...this.queryData };
      params.gmtCreateStart = this.formatDateCustom(params.gmtCreateStart);
      params.gmtCreateEnd = this.formatDateCustom(params.gmtCreateEnd);
      params.pageNum = this.$refs.siruiTable.page.pageNum;
      params.pageSize = this.$refs.siruiTable.page.pageSize;
      params.adminFlag = this.userInfo.adminFlag;

      let customer = params.customerName;
      if (customer) {
        params.customerName = customer[0].partnerZhName;
        params.customerCode = customer[0].partnerCode;
      }
      if (params.nicheDepartmentCode) {
        params.scopeDepartmentNoList = [params.nicheDepartmentCode];
      }
      params = this.filterEmpty(params);
      console.log('processedParams', params);
      this.selectedItems = [];
      this.loading = true;
      const { data } = await this.$axios.post(MERCHANTAPI.LIST_MERCHANT_CENTER, params);
      if (data && data.data && data.code == 0) {
        console.log('merchantRes', data);
        this.tableData = data.data.records || [];
        this.$refs.siruiTable.setPageTotal(data.data.total);
        this.$refs.siruiTable.setPageSize(data.data.size);
      } else {
        this.$message.error(data.msg);
      }
      //清空选择fixme
      this.selectedItems = [];
      this.loading = false;
    },
    // 获取当前登录人所在的部门
    getDepartmentList(code) {
      const params = {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: code,
      };
      this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
        if (res.data.code === 0) {
          this.departList = (res.data.data.personDepartmentInfo || []).map((v) => {
            return {
              label: v.personDepartmentName,
              value: v.personDepartmentCode,
            };
          });
        } else {
          this.departList = [];
        }
      });
    },
    changeMethod({ val, prop }) {
      if (prop == 'nicheCompanyNo') {
        this.queryData.nicheDepartmentCode = null;
        this.getDepartmentList(val);
      }
      console.log(val, prop, '触发');
      // const rowData = val[0];
    },
  },
  mounted() {},
};
